module.exports = __webpack_public_path__ + "static/media/cardoso.db750375.png";